import { Component, OnInit } from '@angular/core';
import { FormGroup, FormControl, Validators } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { ClientUser, FullClientUser } from 'src/models/ClientUser';
import { ApiService } from '../api.service';
import { LocalitiAuthService } from '../localiti-auth.service';

@Component({
  selector: 'app-edit-account',
  templateUrl: './edit-account.component.html',
  styleUrls: ['./edit-account.component.scss']
})
export class EditAccountComponent implements OnInit {

  public accountForm: FormGroup|null = null ;

  constructor(private route: ActivatedRoute, private auth: LocalitiAuthService, private api: ApiService, private router: Router) {

  }
  async save(form: any) {
    const fullClient : FullClientUser = {
      id: form.id,
      name: form.name,
      phone: form.phone,
      address1: form.address1,
      address2: form.address2,
      address3: form.address3,
      city: form.city,
      state: form.state,
      postal: form.postal,
      country: form.country,
      email: form.email,
      isApproved: form.isApproved,
      isDisabled: form.isDisabled,
      licensedLocationCount: form.licensedLocationCount,
      licensedRetailerCount: form.licensedRetailerCount
    };
    this.isLoading = true;
    try {
      alert(form.id);
      const ret = await this.api.patchClientUser(fullClient, fullClient.id);
      console.log(ret);
      if (ret.id == (await this.auth.user).uid) {
         await this.auth.forceReauth();
      }
    } catch(e) {
      console.error(e);
    } finally {
      this.isLoading = false;
    }
  }
  public hasError = (controlName: string, errorName: string) =>{
    if (!this.accountForm) {
      return false;
    }
    if (!this.accountForm.contains(controlName)) {
      return false;
    }

    return this.accountForm.controls[controlName].hasError(errorName);
  }
  isLoading = true;
  sub;
  async ngOnInit() {
    this.isLoading = true;
    this.sub = this.route.params.subscribe(async params => {
      if (params["userId"] != "me" && params["userId"] != (await this.auth.user).uid && !(await this.auth.isGlobalAdmin)) {
        this.router.navigate(['/welcome']);
      } else {
        const clientUser = await this.api.getClientUser(params["userId"]);
        this.accountForm = new FormGroup({
          id: new FormControl(clientUser.id, [Validators.required]),
          name: new FormControl(clientUser.name, [Validators.required, Validators.maxLength(100)]),
          phone: new FormControl(clientUser.phone, [Validators.required, Validators.pattern("[0-9]{10}")]),
          email: new FormControl(clientUser.email, [Validators.required, Validators.email]),
          address1: new FormControl(clientUser.address1||'', [Validators.required]),
          address2: new FormControl(clientUser.address2||'', []),
          address3: new FormControl(clientUser.address3||'', []),
          city: new FormControl(clientUser.city||'', [Validators.required]),
          state: new FormControl(clientUser.state||'', [Validators.required]),
          postal: new FormControl(clientUser.postal||'', [Validators.required]),
          country: new FormControl(clientUser.country||'', [Validators.required]),
          isApproved: new FormControl(clientUser.isApproved, [Validators.required]),
          isDisabled: new FormControl(clientUser.isDisabled, [Validators.required]),
          licensedLocationCount: new FormControl(clientUser.licensedLocationCount, [Validators.required]),
          licensedRetailerCount: new FormControl(clientUser.licensedRetailerCount, [Validators.required])
        });  
      }
      this.isLoading = false;
    });
  }


}
